import React, { useContext, memo } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ roles, designations }) => {
  const { user, loading } = useAuth();

  //  WAIT until auth is ready
  if (loading) {
    return null; // or loader/spinner
  }

  if (!user) {
    return <Navigate to="/smartcity/login" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/smartcity/unauthorizedpage" replace />;
  }

  // Designation check (Clerk/Officer etc)
  // Assuming 'designation' is a field in your JWT/User object
  if (designations && !designations.includes(user.designation)) {
    return <Navigate to="/smartcity/unauthorizedpage" replace />;
  }

  return <Outlet />;
};

export default memo(ProtectedRoute);
